import { Module } from '@/models/Module';
import http from '@/services/HttpService';
import { cancelUpload, uploadFile } from '@/services/S3Service';
import { ApplicationState } from '@/store';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from './Modal';
import './style.scss';

interface PeopleMassImportProps {
    onChange: () => void;
}

export interface ErroTotal {
    totalLicenses: number;
    totalLicensesRequested: number;
}

const PeopleMassImport = ({ onChange }: PeopleMassImportProps) => {
    const {
        data: {
            user: { orgId, applicationId },
        },
    } = useSelector((state: ApplicationState) => state.identity);
    const {
        data: { massImport, ...strings },
    } = useSelector((state: ApplicationState) => state.locale);
    const appOrganization = useSelector((state: ApplicationState) => state.appOrganization.data);

    const inputFile = useRef<HTMLInputElement>(null);
    const [key, setKey] = useState<string>('');
    const [progress, setProgress] = useState(0);
    const [uploading, isUploading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const [error2, setError2] = useState<boolean>(false);
    const [errorTotal, setErrorTotal] = useState<ErroTotal | null>(null);

    const handleSelectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length === 1) {
            isUploading(true);
            const _file = e.target.files[0];
            const filename = `${Date.now()}-people_of_app_${applicationId}_org_${orgId}.xlsx`;
            const _key = `person-batch-create/${filename}`;
            setKey(_key);
            await uploadFile(_file, _key, setProgress)
                .then(async (value) => {
                    setProgress(0);
                    isUploading(false);
                    const sendTo = `tracking/people/applications/${applicationId}/organizations/${orgId}/person-batch-data`;
                    await http
                        .post(sendTo, { filename, moduleIds: appOrganization.modules.map((m: Module) => m.id) })
                        .then((response) => {})
                        .catch((error) => {
                            const status = error.response.status;
                            if (status === 495) {
                                const { totalLicenses, totalLicensesRequested } = JSON.parse(error.response.data.message);
                                setError(true);
                                setErrorTotal({
                                    totalLicenses,
                                    totalLicensesRequested,
                                });
                            } else {
                                setError2(true);
                            }
                        });
                })
                .catch((reason) => {
                    setProgress(0);
                    isUploading(false);
                    setError2(true);
                });
        }
    };

    const buttonSelectFile = (e: any) => {
        if (inputFile.current) {
            inputFile.current.click();
        }
        e.preventDefault();
    };

    const handleCancelUpload = () => {
        if (key) {
            cancelUpload(key);
            setProgress(0);
            isUploading(false);
        }
    };

    return (
        <>
            <input
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={handleSelectFile}
                ref={inputFile}
                style={{ display: 'none' }}
                type="file"
            />
            <button className="dropdown-item pt-3 pb-3" data-target="#progress-modal" data-toggle="modal" onClick={buttonSelectFile} type="button">
                <i className="material-icons-outlined va-t mr-1">unarchive</i>
                {massImport.CHOSE_FILE}
            </button>
            <Modal>
                <div className={`modal-basic ${uploading ? 'show' : ''}`}>
                    <div>
                        <h1>{massImport.PROCESSING}</h1>
                        <p>{massImport.FEW_SECONDS}</p>
                        <button onClick={handleCancelUpload}>{strings.CANCEL}</button>
                    </div>
                </div>

                <div className={`modal-basic ${error ? 'show' : ''}`}>
                    <div>
                        <i className="material-icons-outlined align-middle ico">error</i>
                        <h1>{massImport.NUMBER_USERS}</h1>
                        <p>{massImport.EXCEEDED_LIMIT}</p>
                        <h1 className="mt-5 text-primary">
                            {massImport.TOTAL_LICENCES.replace('%n', errorTotal?.totalLicenses ? errorTotal.totalLicenses.toString() : '')}
                        </h1>
                        <p className="text-primary">
                            {massImport.TOTAL_RECORDS.replace(
                                '%n',
                                errorTotal?.totalLicensesRequested ? errorTotal.totalLicensesRequested.toString() : '',
                            )}
                        </p>
                        <button
                            className="btn btn-primary pl-5 pr-5"
                            onClick={() => {
                                setError(false);
                                setErrorTotal(null);
                            }}
                            type="button"
                        >
                            Ok
                        </button>
                    </div>
                </div>

                <div className={`modal-basic ${error2 ? 'show' : ''}`}>
                    <div>
                        <i className="material-icons-outlined align-middle ico">error</i>
                        <h1>{massImport.PRECONDITION}</h1>
                        <p>{massImport.PRECONDITION_REV}</p>
                        <button
                            className="btn btn-primary pl-5 pr-5"
                            onClick={() => {
                                setError2(false);
                            }}
                            type="button"
                        >
                            Ok
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default PeopleMassImport;
